import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const CreateWhiteboardMutation: GraphQLTaggedNode = graphql`
	mutation WhiteboardExtensionCreateWhiteboardMutation(
		$createdInContentId: ID!
		$spaceKey: String
	) {
		createContentInline(
			input: { createdInContentId: $createdInContentId, spaceKey: $spaceKey, type: "whiteboard" }
		) {
			id
		}
	}
`;
